<div class="container">
  <div class="container-table">
    <header class="top-header">
      <h3>Registers</h3>
      <p>Manage visitor registers</p>
    </header>

    <div class="tab-head">
      <div class="search-bar wide-search-bar">
        <app-generic-search
          [apiUrl]="'visitor-management/registers'"
          [resultsApiUrl]="'visitor-management/registers'"
          [apiBaseUrl]="visitorApiBaseUrl"
          [method]="'GET'"
          [searchParamName]="'search'"
          [extraBody]="searchExtras"
          [pageSize]="recordsPerPage"
          [minChars]="2"
          (resultsFetched)="onResults($event)">
        </app-generic-search>
      </div>
      <div class="filters table-filters">
        <div class="filter">
          <label>Location</label>
          <select [(ngModel)]="selectedLocation" (change)="onLocationFilterChange()">
            <option [ngValue]="null">All</option>
            <option *ngFor="let location of locations" [ngValue]="location.id">
              {{ location.village_or_locality_name }} - {{ location.district_name }}
            </option>
          </select>
        </div>
      </div>
      <button (click)="createRegister()" class="btn-action">
        <fa-icon [icon]="['fas', 'square-plus']"></fa-icon>
        Create New
      </button>
    </div>

    <div class="responsive-table-wrapper">
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Fields</th>
            <th>Steps</th>
            <th>Location</th>
            <th>Active</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let register of registers">
            <td>{{ register.name }}</td>
            <td>{{ fieldCounts[register.id] || 0 }}</td>
            <td>{{ stepsCount[register.id] || 1 }}</td>
            <td>{{ getLocationLabel(register.location) }}</td>
            <td>
              <span [ngClass]="register.is_active ? 'green-circle' : 'red-circle'"></span>
            </td>
            <td>
              <button class="action-button bt-edit" (click)="editRegister(register.id)" title="Edit">
                <span><fa-icon [icon]="['fas', 'pen']"></fa-icon></span>
              </button>
              <button class="action-button bt-edit" (click)="copyRegister(register)" title="Copy">
                <span><fa-icon [icon]="['fas', 'copy']"></fa-icon></span>
              </button>
            </td>
          </tr>
          <tr *ngIf="registers.length === 0">
            <td colspan="6">No registers found.</td>
          </tr>
        </tbody>
      </table>

      <div class="footer">
        <div class="total-records">Total Records: {{ totalRecords }}</div>
        <div class="pagination-controls">
          <label for="recordsPerPage">Records per page</label>
          <select id="recordsPerPage" [(ngModel)]="recordsPerPage" (change)="selectPageSize()">
              <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
          </select>
          <span>{{ currentPage }} / {{ totalPages }}</span>
          <button (click)="previous()" class="change-page" title="Previous page">
            <fa-icon [icon]="['fas', 'angle-left']"></fa-icon>
          </button>
          <button (click)="next()" class="change-page" title="Next page">
            <fa-icon [icon]="['fas', 'angle-right']"></fa-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
